<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white"> Dashboard</router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Community</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="card">
                        <div class="card-body">
                            <modal :show.sync="modals.CommunityModal" modal-classes="modal-dialog-centered modal-md">
                                <div class="card bg-secondary border-0 mb-0">
                                    <div class="card-body">
                                        <PageSpinner :onloader="onloader" />
                                        <form role="form">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Name</label>
                                                        <vue-editor id="CommunityNameval" v-model="CommunityNameVal"
                                                            ref="CommunityNameval">

                                                        </vue-editor>
                                                    </div>
                                                </div>

                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Details</label>
                                                        <vue-editor id="CommunityDetailsVal"
                                                            v-model="CommunityDetailsVal"
                                                            ref="CommunityDetailsVal">

                                                        </vue-editor>
                                                    </div>
                                                </div>                                               
                                                <div class="col-md-12 pb-2">
                                                    <div class="row">
                                                        <div class="col">
                                                            <img v-if="CommunityLogoVal" :src="CommunityLogoVal"
                                                                class="img-fluid" />
                                                            <img v-else src="/img/brand/empty.png" class="img-fluid" />
                                                        </div>
                                                        <div class="col">
                                                            <ImageUploader
                                                                @emitOutImgPathval="UpdateCommunityLogoVal" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <template slot="footer">

                                    <base-button type="default" @click="modals.CommunityModal = false">Cancel
                                    </base-button>
                                    <base-button type="success" @click.prevent="submitdata()">Submit
                                    </base-button>
                                </template>
                            </modal>

                            <div>
                                <div class="form-inline">
                                    <button class="btn btn-success" v-on:click="openNew()">
                                        <i class="fa fa-edit"></i> New
                                    </button>
                                </div>
                                <div class="justify-content-end form-inline">
                                    <base-input class="input-group-alternative" placeholder="Search here..."
                                        addon-left-icon="fa fa-search" v-model="searchValueval">
                                    </base-input>
                                </div>
                                <div v-if="CommunityItems">
                                    <div v-for="item in CommunityItems" :key="item.communityId">
                                        <div class="card mt-2">
                                            <div class="card-body bg-secondary">
                                                <div class="card">
                                                    <div class="row">
                                                        <div class="col-lg-3">
                                                            <img :src="item.communityLogo"
                                                                class="card-img-top" alt="...">
                                                        </div>
                                                        <div class="col-lg-9">
                                                            <h5 class="card-title" v-html="item.communityName"></h5>
                                                            <div class="card-text" v-html="item.communityDetails">
                                                            </div>
                                                            <div class="card-footer text-center">
                                                                <button class="btn btn-secondary btn-sm"
                                                                    v-on:click="edititem(item)">
                                                                    <i class="fa fa-edit"></i> Edit
                                                                </button>
                                                                 <button v-if="item.isDeleted" class="btn btn-danger btn-sm"
                                                                    v-on:click="UnDeleteCommunity(item.communityId)">
                                                                    <i class="fa fa-times"></i> Restore
                                                                </button>
                                                                <button v-else class="btn btn-danger btn-sm"
                                                                    v-on:click="DeleteCommunity(item.communityId)">
                                                                    <i class="fa fa-times"></i> Delete
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>

                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { VueEditor } from 'vue2-quill-editor'
import PageSpinner from "@/components/PageSpinner";
import ValidateAccessToken from "@/mixins/ValidateAccessToken.mixins";
import Alert from "@/mixins/Alert.mixins"
import katex from 'katex';
import 'katex/dist/katex.min.css';
import ImageUploader from "@/components/ImageUploader"
window.katex = katex;
export default {
    name: "questionheader",
    mixins: [ValidateAccessToken, Alert],
    components: {
        PageSpinner,
        VueEditor,
        ImageUploader
    },
    data() {
        return {
            accessDetails: null,
            CommunityIdval: 0,
            CommunityNameVal: "",
            CommunityDetailsVal: "",
            DeletedCommentVal: "",
            CommunityLogoVal: null,
            searchValueval: null,
            CommunityItems: null,
            isModified: false,
            onloader: "none",
            paginationMeta: {
                pageNumber: 1,
                pageSize: 10,
                totalPages: 0,
                totalRecords: 0
            },
            editorOption: {
                debug: 'info',
                placeholder: 'Type in here',
                readonlly: true,
                theme: 'snow'
            },
            modals: {
                CommunityModal: false
            }
        };
    },
    methods: {
        openNew() {
            this.isModified = false;
            this.modals.CommunityModal = true
        },
        resetInput() {
            this.CommunityIdval = 0;
            this.CommunityNameVal = "";
            this.CommunityDetailsVal = "";
            this.CommunityLogoVal = null;
            this.isModified = false;
        },
        edititem(item) {
            this.resetInput();
            this.CommunityIdval = item.communityId;
            this.CommunityNameVal = item.communityName;
            this.CommunityDetailsVal = item.communityDetails;
            this.CommunityLogoVal = item.communityLogo;
            this.isModified = true;
            this.modals.CommunityModal = true;
        },
        submitdata() {
            let CommunityId = this.CommunityIdval;
            let CommunityName = this.CommunityNameVal;
            let CommunityDetails = this.CommunityDetailsVal;
            let CommunityLogo = this.CommunityLogoVal;
            let userdata = {};
            this.onloader = "flex";
            let operationVal = "";
            if (this.isModified == false) {
                operationVal = "Community/CreateCommunity";
                userdata = {
                    CommunityName,
                    CommunityLogo,
                    CommunityDetails,
                }
            } else {
                operationVal = "Community/UpdateCommunity";
                userdata = {
                    CommunityId,
                    CommunityName,
                    CommunityLogo,
                    CommunityDetails,
                }
            }
            this.$store
                .dispatch(operationVal, userdata)
                .then((resp) => {
                    this.onloader = "none";
                    if (resp.responseCode == '00') {
                        this.GetCommunitiesForPortal();
                        this.resetInput();
                        this.modals.CommunityModal = false;
                        this.ShowAlertSuccess('Submitted successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        UpdateCommunityLogoVal(data) {
            this.CommunityLogoVal = data;
        },
        GetCommunitiesForPortal() {
            this.$store
                .dispatch("Community/GetCommunitiesForPortal")
                .then((resp) => {
                   if (resp.responseCode == '00') {
                        this.CommunityItems = resp.data;
                    } 
                    this.onloader = "none";
                })
                .catch((err) => {

                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');

                });
        },
        DeleteCommunity(CommunityId) {
            this.onloader = "flex";
            if (CommunityId > 0) {
                this.DeletedCommentVal = "NIL";
                let DeletedComment = this.DeletedCommentVal;
                let userdata = {
                    CommunityId,
                    IsDeleted: true,
                    DeletedComment
                }
                this.$store
                    .dispatch("Community/DeleteUndeleteCommunity", userdata)
                    .then((resp) => {
                        this.onloader = "none";
                        if (resp.responseCode == '00') {
                            this.GetCommunitiesForPortal();
                            this.ShowAlertSuccess('Submitted successfully', '');
                        } else {
                            this.ShowAlertError(resp.responseMessage, '');
                        }

                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
         UnDeleteCommunity(CommunityId) {
            this.onloader = "flex";
            if (CommunityId > 0) {
                this.DeletedCommentVal = "NIL";
                let DeletedComment = this.DeletedCommentVal;
                let userdata = {
                    CommunityId,
                    IsDeleted: false,
                    DeletedComment
                }
                this.$store
                    .dispatch("Community/DeleteUndeleteCommunity", userdata)
                    .then((resp) => {
                        this.onloader = "none";
                        if (resp.responseCode == '00') {
                            this.GetCommunitiesForPortal();
                            this.ShowAlertSuccess('Submitted successfully', '');
                        } else {
                            this.ShowAlertError(resp.responseMessage, '');
                        }

                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        }
    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSuperAdmin == true ||
            userDetails.isAdmin == true ||
            userDetails.isSupportAdmin == true
        ) {
            this.GetCommunitiesForPortal();
        } else {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        }
    },
};
</script>

<style></style>